import { Path } from 'paper';

import { average } from './math';

export function getSvgPathFromStroke(points: number[][], closed = true) {
  const len = points.length;

  if (len < 4) {
    return ``;
  }

  let a = points[0];
  let b = points[1];
  const c = points[2];

  let result = `M${a[0].toFixed(2)},${a[1].toFixed(2)} Q${b[0].toFixed(
    2,
  )},${b[1].toFixed(2)} ${average(b[0], c[0]).toFixed(2)},${average(b[1], c[1]).toFixed(2)} T`;

  for (let i = 2, max = len - 1; i < max; i++) {
    a = points[i];
    b = points[i + 1];
    result += `${average(a[0], b[0]).toFixed(2)},${average(a[1], b[1]).toFixed(2)} `;
  }

  if (closed) {
    result += 'Z';
  }

  return result;
}

/**
 * Paper.js Path.translate() doesn't preserve multiple subpaths,
 * so we need to split them up and translate each subpath separately.
 */
export function translateSvgPathWithSubpaths(
  pathData: string,
  dx: number,
  dy: number,
): string {
  if (dx === 0 && dy === 0) return pathData;

  const subpaths = pathData.split(/(?=M)/);

  return subpaths
    .map((subpath) => {
      if (!subpath.trim()) return '';

      const path = new Path(subpath);
      path.translate({ x: dx, y: dy });
      return path.pathData;
    })
    .join('');
}
